module.exports = __webpack_public_path__ + "static/411staff-a-38522505a6e5084b9252f8516d369e2f.png";